import { __extends } from "tslib";
import { Event } from './Event';
var SoftKeyboardEvent = /** @class */ (function (_super) {
    __extends(SoftKeyboardEvent, _super);
    function SoftKeyboardEvent(type, bubbles, cancelable, relatedObjectVal, triggerTypeVal) {
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    SoftKeyboardEvent.classInitializer = null;
    SoftKeyboardEvent.classSymbols = null;
    SoftKeyboardEvent.instanceSymbols = null;
    // JS -> AS Bindings
    SoftKeyboardEvent.SOFT_KEYBOARD_ACTIVATE = 'softKeyboardActivate';
    SoftKeyboardEvent.SOFT_KEYBOARD_DEACTIVATE = 'softKeyboardDeactivate';
    SoftKeyboardEvent.SOFT_KEYBOARD_ACTIVATING = 'softKeyboardActivating';
    return SoftKeyboardEvent;
}(Event));
export { SoftKeyboardEvent };
